<template>
    <b-form-group
        :id="name"
        :label-for="fieldInputId"
        :label="label"
        :state="state"
    >
        <template v-slot:invalid-feedback>
            <slot name="invalid-feedback"></slot>
        </template>
        <template v-slot:description>
            <slot name="description"></slot>
        </template>

        <b-input-group>
            <b-form-input
                :id="fieldInputId"
                v-model="vuelidatePassword.$model"
                :state="state"
                :type="showValue ? 'text' : 'password'"
            />

            <template v-slot:append>
                <b-input-group-text>
                    <i
                        v-if="showValue"
                        :title="$t('passwordfield.hidepassword')"
                        class="far fa-eye-slash clickable"
                        @click="toggleVisibility"
                    />
                    <i
                        v-else
                        :title="$t('passwordfield.showpassword')"
                        class="far fa-eye clickable"
                        @click="toggleVisibility"
                    />
                </b-input-group-text>
            </template>
        </b-input-group>
    </b-form-group>
</template>
<script>
    export default {
        name: 'password-field',
        props: {
            vuelidatePassword: {
                type: Object,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                showValue: false,
            };
        },
        computed: {
            fieldInputId() {
                return this.name + '-input';
            },
            state() {
                if (!this.vuelidatePassword.$dirty) {
                    return null;
                }
                return !this.vuelidatePassword.$error;
            },
        },
        methods: {
            toggleVisibility() {
                this.showValue = !this.showValue;
            }
        },
    };
</script>
